<script lang="ts">
  import { appState } from '../state.svelte';
  import { t } from '../i18n/index';

  let {
    onMinimize,
    onEditProfile,
    onClear,
  }: {
    onMinimize: () => void;
    onEditProfile: () => void;
    onClear: () => void;
  } = $props();

  const title = $derived(appState.widgetConfig?.title ?? '');
  const name = $derived(appState.widgetConfig?.name ?? 'Support');
  const intro = $derived(appState.widgetConfig?.intro_text ?? '');
  // Edit icon only after the visitor has a name (submitted VisitorForm).
  // Trash icon only after at least one real message has been exchanged —
  // clearing an empty thread is meaningless.
  const showEdit = $derived(!!appState.visitor.name);
  const showClear = $derived(appState.messages.length > 0);
</script>

<header
  class="tashimoto-support-bg-blue-500 tashimoto-support-text-white tashimoto-support-px-4 tashimoto-support-py-3 tashimoto-support-flex tashimoto-support-items-start tashimoto-support-justify-between tashimoto-support-gap-2"
  data-testid="support-header"
>
  <div class="tashimoto-support-flex-1 tashimoto-support-min-w-0">
    {#if title}
      <h2 class="tashimoto-support-text-base tashimoto-support-font-semibold tashimoto-support-leading-tight">
        {title}
      </h2>
    {/if}
    <p class="tashimoto-support-text-xs tashimoto-support-opacity-90 tashimoto-support-truncate">
      {name}
    </p>
    {#if intro}
      <p class="tashimoto-support-text-xs tashimoto-support-opacity-75 tashimoto-support-mt-0.5 tashimoto-support-truncate">
        {intro}
      </p>
    {/if}
  </div>

  <div class="tashimoto-support-flex tashimoto-support-items-center tashimoto-support-gap-1">
    {#if showEdit}
      <button
        type="button"
        class="tashimoto-support-p-1 tashimoto-support-rounded hover:tashimoto-support-bg-blue-600"
        aria-label={t('header.editProfile')}
        title={t('header.editProfile')}
        onclick={onEditProfile}
        data-testid="support-header-edit"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M12 20h9"></path>
          <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5Z"></path>
        </svg>
      </button>
    {/if}
    {#if showClear}
      <button
        type="button"
        class="tashimoto-support-p-1 tashimoto-support-rounded hover:tashimoto-support-bg-blue-600"
        aria-label={t('header.clear')}
        title={t('header.clear')}
        onclick={onClear}
        data-testid="support-header-clear"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <polyline points="3 6 5 6 21 6"></polyline>
          <path d="M19 6l-2 14a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L5 6"></path>
          <path d="M10 11v6"></path>
          <path d="M14 11v6"></path>
        </svg>
      </button>
    {/if}
    <button
      type="button"
      class="tashimoto-support-p-1 tashimoto-support-rounded hover:tashimoto-support-bg-blue-600"
      aria-label={t('common.close')}
      title={t('common.close')}
      onclick={onMinimize}
      data-testid="support-header-minimize"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>
  </div>
</header>
